import { Component, Input, Output, EventEmitter  } from "@angular/core";
import { UtilsService } from 'app/environment/services/utils.service';
import {CryptoDataService} from '../../../core/services/crypto.data.service';
import { IConnectorField, IConnectorType, ISAPConnector } from "app/connect/core/IConnector";

@Component({
    selector: 'connectors-sap',
    templateUrl: 'connectors-sap.component.html',
    styleUrls: ['connectors-sap.component.scss']
})
export class ConnectorsSapComponent {

    @Input() selectedConnector: ISAPConnector;
    @Input() selectedConnectorType: IConnectorType;
    @Input() displayName: string;
    @Input() name: string;
    @Input() properties: {[key: string]: IConnectorField};
    @Output() testConnectionEvent = new EventEmitter<string>();

    constructor(public utilsService: UtilsService, private _cryptoDataService: CryptoDataService) { }




    public async getEncryptedPasswords() {
      const newConnector = _.cloneDeep(this.selectedConnector);
      if(this.properties){
       for( const key in newConnector.properties) {
          if(newConnector.properties[key] !== null && this.properties[key] && this.properties[key].type === 'password') {
              newConnector.properties[key] = await this._cryptoDataService.encryptStringPromise(newConnector.properties[key]);
            }
          }
        }
      return newConnector;
    }

    public TestConnection() {
      this.testConnectionEvent.next();
    }
}
